module.exports = __webpack_public_path__ + "static/media/valor3_1.b524e0f1.png";